import { combineReducers } from "redux";
import authReducer from "./authReducer";
import gameReducer from "./gameReducer";
import voucherReducer from "./voucherReducer";
import userReducer from "./userReducer";
import teamReducer from "./teamReducer";
import faqReducer from "./faqReducer";
import contentReducer from "./contentReducer";
import feedbackReducer from "./feedbackReducer";
import galleryReducer from "./galleryReducer";
import mailReducer from "./mailReducer";
const rootReducer = combineReducers({
  auth: authReducer,
  game: gameReducer,
  voucher: voucherReducer,
  user: userReducer,
  team: teamReducer,
  faq: faqReducer,
  mail: mailReducer,
  feedback: feedbackReducer,
  gallery: galleryReducer,
  content: contentReducer,
});

export default rootReducer;
